import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { UseMutationResult } from '@tanstack/react-query'
import { COMMUNITY_SECURE_GLOBAL_PREFIX } from 'shared/api/constants/api-constants'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import type { InvitationInterface } from 'modules/community/types/invitation-interface'
import { communityKeys } from './key-factory'

export const useResendInvitation = ({
  communityPath,
}: {
  communityPath: string
}): UseMutationResult<InvitationInterface, Error, number> => {
  const queryClient = useQueryClient()
  const { fetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.post,
    InvitationInterface
  >({ method: RequestMethodsEnum.post })

  return useMutation({
    mutationKey: communityKeys.invitations.resend(communityPath),
    mutationFn: async (invitationId: number) =>
      fetcher(
        `${COMMUNITY_SECURE_GLOBAL_PREFIX}/${communityPath}/invitations/${invitationId}/resend`,
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: communityKeys.invitations.lists() })
    },
    retry: false,
  })
}
